import { useEffect, useState } from "react";
import MainHeader from "./header";
import MainDrawer from "./drawer";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 0 && window.innerWidth <= 1024) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex h-screen bg-gray-100">
      <MainDrawer isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="flex-1 transition-all duration-300 overflow-y-scroll">
        <MainHeader isOpen={isOpen} setIsOpen={setIsOpen} />
        <div
          className={`h-full overflow-auto p-6 pr-[4rem] pt-[90px] transition-all duration-300 bg-[#05050f] ${
            isOpen ? "pl-[20rem]" : "pl-[9rem] pr-[2.2rem]"
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
